export default __webpack_public_path__ + "static/media/dsv-ups-eu_de.2186c073.svg";